import { IGoal } from "motw_core/Entity/IGoal";
import { IRecentRateChange } from "motw_core/RecentRateChanges/IRecentRateChange";
import { IGoalCardsState } from "source/app/presentation/MainPanel/Goals/GoalCards/Helpers/IGoalCardsState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export const IsGoalBleeding = (goal: IGoal) => {
    const percentChange = Math.floor(GetPercentChange(goal));
    return percentChange < -20;
};

const GetPercentChange = (goal: IGoal) => {
    const goalCards = State.ReadClass<IGoalCardsState>(
        ESharedComponent.GoalCards
    );

    if (!goalCards || !goalCards.state.recentRateChanges) {
        return 0;
    }

    if (goalCards) {
        const rateChangeRecord = goalCards.state.recentRateChanges.find(
            (rrc: IRecentRateChange) => rrc.name === goal.name
        );

        if (rateChangeRecord) {
            return rateChangeRecord.percentChange;
        }
    }

    return 0;
};
